import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import validateAddCategoriesSitePublishers from "../../../../validtions/forms/category-site-publishers/add-categories-site-publishers";
import helperSpinner from "../../../../helpers/spinner";

function EditCategoriesSitePublisher() {
  const initCategoryPublisher = {
    name: "",
  };

  const [categoryPublisher, setCategoryPublisher] = useState(
    initCategoryPublisher
  );
  const [message, setMessage] = useState();

  const history = useHistory();

  const params = useParams();
  const categoryPublisherID = params.id;

  useEffect(() => {
    getCategoryPublisher(categoryPublisherID);
  }, []);

  const getCategoryPublisher = async (categoryPublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categoryPublisher = await sendRequestGetCategoryPublisher(
      categoryPublisherID
    );
    setCategoryPublisher(categoryPublisher);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestGetCategoryPublisher = async (categoryPublisherID) => {
    const headersRequest = getHeaderForRequset();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-site-publishers/" +
          categoryPublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestEditCategoryPublisher = async (
    categoryPublisherID,
    data
  ) => {
    const headersRequest = getHeaderForRequset();

    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-site-publishers/" +
          categoryPublisherID,
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getFormData();

    if (validateAddCategoriesSitePublishers(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateAddCategoriesSitePublishers(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestEditCategoryPublisher(categoryPublisherID, formData)) {
      history.push("/manage/category-publishers/all");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const getFormData = () => {
    return {
      name: document.getElementById("name").value,
    };
  };

  return (
    <>
      <Sidebar openItem="manage-category-publisher-menu" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ویرایش سایت نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <form onSubmit={sendForm}>
                {message}
                <div className="form-group">
                  <label>آدرس سایت</label>
                  <input
                    id="name"
                    type="text"
                    className="form-control"
                    defaultValue={categoryPublisher.cas_name}
                  />
                </div>
                <button className="btn btn-primary">ویرایش</button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditCategoriesSitePublisher;
